<ciciam-frame-front [hideLanguageButton]="true"> </ciciam-frame-front>

<div
  class="overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none justify-center items-center flex max-h-screen hide-scroll-bar"
>
  <div
    class="relative md:w-[80vw] w-[90vw] min-w-[300px] my-6 mx-auto max-w-3xl max-h-screen"
  >
    <!--content-->
    <div
      class="border-2 border-notus-primary-500 rounded-2xl shadow-lg relative flex flex-col bg-white outline-none focus:outline-none h-[90vh]"
    >
      <!--header-->
      <div class="flex items-start justify-between p-5 rounded-2xl">
        <h3
          class="text-2xl block flex-grow text-center md:text-left lg:inline-block text-notus-primary-900"
        >
          {{ 'New User Registration' | translate }}
        </h3>
        <tw-dropdown menu [items]="items" class="hidden md:block">
          <img src="/assets/images/language.png" class="cursor-pointer" />
        </tw-dropdown>
      </div>
      <!--body-->
      <div class="relative p-4 flex-auto overflow-x-hidden overflow-y-clip">
        <ciciam-form-register
          *ngIf="!showSuccessMessage"
          (credential)="onRegister($event)"
        ></ciciam-form-register>
        <div
          *ngIf="showSuccessMessage"
          class="text-center flex flex-col justify-center"
        >
          <div class="flex justify-center">
            <flowbite-loading size="1.25rem"></flowbite-loading>
            <span class="block sm:inline mr-2 ml-2">{{ 'Registration successful' | translate }}</span>
          </div>
          <div class="block sm:inline pt-2">{{ 'Going back to login page in 5 seconds...' | translate }}</div>
          <div class="block sm:inline pt-8 text-sm">
            {{ 'if you are not redirected automatically' | translate }}
            <span class="underline" (click)="goToLogin()">{{ 'here' | translate }}</span>
            {{ 'login.' | translate }}
          </div>
        </div>
      </div>
      <!--footer-->
      <!-- <div class="flex items-center justify-end p-6 border-t border-solid border-slate-200 rounded-b">
        <button class="text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" (click)="toggleModal()">
          Close
        </button>
        <button class="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" type="button" (click)="toggleModal()">
          Save Changes
        </button>
      </div> -->
    </div>
    <div>&nbsp;</div>
  </div>
</div>
<div class="opacity-50 fixed inset-0 z-40 bg-white"></div>
